"use strict";
/**
 * Created by Jie Gao on 2019-05-09.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvalancheParsedGameData = exports.AvalancheParsedInitData = void 0;
const ParsedGameData_1 = require("../../../core/server/data/ParsedGameData");
const ParsedInitData_1 = require("../../../core/server/data/ParsedInitData");
class AvalancheParsedInitData extends ParsedInitData_1.ParsedInitData {
    get allWinPositions() {
        return this._allWinPositions;
    }
    get reelsAfterCollapse() {
        return this._reelsAfterCollapse;
    }
    constructor(rawData, dataParser) {
        super(rawData, dataParser);
        this._allWinPositions = dataParser.parseAllWinPositions(rawData);
        this._reelsAfterCollapse = dataParser.parseReelsAfterCollapse(rawData);
    }
}
exports.AvalancheParsedInitData = AvalancheParsedInitData;
class AvalancheParsedGameData extends ParsedGameData_1.ParsedGameData {
    get allWinPositions() {
        return this._allWinPositions;
    }
    get reelsAfterCollapse() {
        return this._reelsAfterCollapse;
    }
    get newSymbols() {
        return this._newSymbols;
    }
    get nearWinPositions() {
        return this._nearWinPositions;
    }
    constructor(rawData, dataParser) {
        super(rawData, dataParser);
        this._allWinPositions = dataParser.parseAllWinPositions(rawData);
        this._reelsAfterCollapse = dataParser.parseReelsAfterCollapse(rawData);
        this._newSymbols = dataParser.parseNewSymbols(rawData);
        this._nearWinPositions = dataParser.parseNearWinPositions(rawData);
    }
}
exports.AvalancheParsedGameData = AvalancheParsedGameData;
//# sourceMappingURL=AvalancheParsedServerData.js.map